module.exports = __webpack_public_path__ + "img/partner1.e0434994.png";